import React from 'react';
import {Action} from '@sail/ui';
import type {Wallet} from '@stripe-internal/wallet-connect-wrapper';
import {NetworkBadge} from 'src/v2/components/wallet/NetworkBadge';
import {WalletInfo} from 'src/v2/components/wallet/WalletInfo';
import {COLORS} from 'src/v2/util/color';
import {WalletRegistry} from 'src/v2/util/WalletRegistry';

interface WalletItemProps {
  wallet: Wallet;
  isActive: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const WalletItem: React.FC<WalletItemProps> = ({
  wallet,
  isActive,
  onClick,
  disabled = false,
}) => {
  const walletOption = WalletRegistry.getWalletOption({
    provider: wallet.type,
    key: wallet.key,
  });

  if (!walletOption) {
    throw new Error('Wallet option not found in WalletItem');
  }

  return (
    <Action
      disabled={disabled}
      onPress={onClick}
      css={{
        stack: 'x',
        borderRadius: 'small',
        borderColor: isActive ? COLORS.borderSelected : COLORS.borderOnLight,
        borderWidth: 'small',
        borderStyle: 'solid',
        padding: 'space.150',
        alignY: 'center',
        distribute: 'space-between',
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'default' : 'pointer',
      }}
    >
      <WalletInfo walletOption={walletOption} address={wallet.address} />
      <NetworkBadge network={wallet.network} />
    </Action>
  );
};
